export default class ProductsError extends Error {}
